import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';

import Configuration from '../Config';
import { getCard, updateCard } from '../actions/CardActions';
import CardForm from '../components/CardForm';


const validation = Configuration.Validations.editStockAccount;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditCard extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getCard(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateCard(this.props.card.id, values));
    }

    render() {
        if(!this.props.card || !this.props.card.name) {
            return <Pane>Se incarca...</Pane>
        }
        
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/cards">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista carti
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/cards/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Carte - <strong>{this.props.card.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CardForm 
                            isEdit={true}
                            initialValues={this.props.card}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.cards.errors.type === 'validation' ? mapValidationErrors(state.cards.errors.fields): [],
        card: state.cards.current
    }
}

export default connect(mapStateToProps)(EditCard);